module.exports = __webpack_public_path__ + "img/paifeng.61fde770.svg";